import React from 'react';
import { Authenticator, Menu, MenuItem, View, Divider  } from '@aws-amplify/ui-react';
import '@aws-amplify/ui-react/styles.css';
import logo from '../media/Logo-Ressolve.png'; // Asegúrate de que la ruta al logo sea correcta
import { useNavigate } from 'react-router-dom';
import './Header.css';

function Header(props) {
  
  const navigate = useNavigate();
  const handleAdminPage = () => {
    navigate("/admin")
  }
  const handleHomePage = () => {
    navigate("/")
  }
  const handleLoadFilesPage = () => {
    navigate("/load-files")
  }

  return (
    <Authenticator>
      {({ signOut, user }) => (
        <header style={headerStyle}>
          <div style={leftSectionStyle}>
            <img src={logo} alt="Logo" style={logoStyle} onClick={handleHomePage}/>
            {/* <span>Hola, {user.username}</span> */}
          </div>
          <View width="4rem" style={menuStyle}>
            <Menu menuAlign="end">
              <MenuItem onClick={handleHomePage} className='option'>Inicio</MenuItem>
              <>{
                props.role === 'Administrador'? (<><MenuItem onClick={handleAdminPage} className='option'>Administrar</MenuItem></>):(
                  <></>
                )
              }
              </>
              
              <MenuItem onClick={handleLoadFilesPage} className='option'>Cargar</MenuItem>
              <Divider />
              <MenuItem onClick={signOut} className='option'>Salir</MenuItem>
            </Menu>
          </View>
          
        </header>
      )}
    </Authenticator>
  );
}

const menuStyle = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '10px 20px',
  backgroundColor: '#282c34',
  color: 'white'
};

const headerStyle = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '10px 20px',
  backgroundColor: '#282c34',
  color: 'white'
};

const leftSectionStyle = {
  display: 'flex',
  alignItems: 'center'
};

const logoStyle = {
  width: '200px',
  height: '40px',
  marginRight: '10px'
};

export default Header;
